import React from 'react';

import {ConsultationRequestResBody} from '../../server/types/consultation.types';
import {ConsultationRequestAcceptanceScreen} from '../../screens';
import {Platform, View} from 'react-native';
import { StyleSheet } from 'react-native';

interface ConsultationAcceptance {
  hasConsultationFee: boolean;
  consultationFee: number;
  note?: string;
}

interface ConsultationRequestAcceptanceModalProps {
  serviceRequest?: ConsultationRequestResBody;
  onConfirm: () => void;
}

function ConsultationRequestAcceptanceModal(
  props: ConsultationRequestAcceptanceModalProps,
) {

  return (
    <View style={rneStyles.root}>
      <ConsultationRequestAcceptanceScreen
        serviceRequest={props.serviceRequest}
        onConfirm={props.onConfirm}
      />
    </View>
  );
}

const rneStyles = StyleSheet.create(({
  root: {
    height: '100%',
  },
}));

export default ConsultationRequestAcceptanceModal;
